const investmentEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/budgeting/investments` as const,
  template: () => '/templates/investment-import' as const,
  import: (companyId: string) => `/companies/${companyId}/budgeting/investments/import` as const,
  export: (companyId: string) => `/companies/${companyId}/budgeting/investments/summary/export` as const,
  detail: (companyId: string, investmentId: number) =>
    `/companies/${companyId}/budgeting/investments/${investmentId}` as const,
  summary: (companyId: string) => `/companies/${companyId}/budgeting/investments/summary` as const,
  depreciationVoucherPreview: (companyId: string) => `/finadeck/deprecations/${companyId}/preview` as const,
  depreciationVoucher: (companyId: string) => `/finadeck/deprecations/${companyId}` as const
}

export default investmentEndpoints
